import { Api } from '../api';
import { lsb } from '../endpoints';
import type { ApiPaginate, ApiResponse, FileResponse } from '../../models';
import type {
  DownloadInquiryAttachmentRequest,
  GetInquiriesRequest,
  GetInquiriesResponse,
  GetInquiryRequest,
  GetInquiryResponse,
  GetSpecialOffersRequest,
  GetSpecialOffersResponse,
  PostInquiryRequest,
  PostRequestRequest,
  PostRequestResponse,
  PostSpecialOfferRequest,
  PostSpecialOfferResponse,
} from './models';

export class LsbApi extends Api {
  static getSpecialOffers = (request: GetSpecialOffersRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<GetSpecialOffersResponse[]>>({ url: lsb.specialOffers(), queryParams: request, signal });

  static postSpecialOffer = (request: PostSpecialOfferRequest, signal?: AbortSignal) =>
    this.post<PostSpecialOfferRequest, ApiResponse<PostSpecialOfferResponse>>({ url: lsb.specialOffers(), data: request, signal });

  static postRequest = (request: PostRequestRequest, signal?: AbortSignal) =>
    this.post<PostRequestRequest, ApiResponse<PostRequestResponse>>({ url: lsb.requests(), data: request, signal });

  static getInquiries = (request: GetInquiriesRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<GetInquiriesResponse>>({ url: lsb.inquiries(), queryParams: request, signal });

  static getInquiry = (request: GetInquiryRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<GetInquiryResponse>>({ url: lsb.inquiry(request.inquiryId), signal });

  static postInquiry = (request: PostInquiryRequest, signal?: AbortSignal) =>
    this.post<PostInquiryRequest, ApiResponse<undefined>>({ url: lsb.postInquiry(), data: request, signal });

  static downloadInquiryAttachment = (request: DownloadInquiryAttachmentRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: lsb.attachment(request.attachmentId), signal });
}
